import { renderTemplateHtml } from "../utils/htmlTemplates";

export const variants = [
  "modern",
  "dark",
  "minimal",
  "receipt-paper",
  "corporate",
  "neo-brutalist",
  "custombrutalist",
  "wallet-pass",
  "vibrant-mesh",
  "glass",
  "stealth",
];

export const getRandomVariant = () => {
  return variants[Math.floor(Math.random() * variants.length)];
};

const TRANSPARENT_PIXEL =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBTAA7";

export const ReceiptCard = ({
  data,
  title = "PAYMENT COMPLETE",
  html,
}) => {
  if (!html) return null;

  const sanitized = renderTemplateHtml(html, {
    ...data,
    title,
    baseImage: data?.baseImage || TRANSPARENT_PIXEL,
    customerMessage: data?.customerMessage || "Thank you for your contribution.",
  });
  return <div dangerouslySetInnerHTML={{ __html: sanitized }} />;
};
